require("!!C:\\Projects\\Github\\Ignite\\Ignite.Web\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Projects\\Github\\Ignite\\Ignite.Web\\node_modules\\raw-loader\\index.js!C:\\Projects\\Github\\Ignite\\Ignite.Web\\wwwroot\\lib\\layerslider\\js\\layerslider.transitions.js")+"\n\n// SCRIPT-LOADER FOOTER\n//# sourceURL=script:///C:/Projects/Github/Ignite/Ignite.Web/wwwroot/lib/layerslider/js/layerslider.transitions.js")


//////////////////
// WEBPACK FOOTER
// C:/Projects/Github/Ignite/Ignite.Web/node_modules/script-loader!C:/Projects/Github/Ignite/Ignite.Web/wwwroot/lib/layerslider/js/layerslider.transitions.js
// module id = 515
// module chunks = 2